import React, { useEffect, useState } from "react";
import backicon from "./../../../../../../Assets/icons/backIcon.svg";
import "./index.scss";
import { useNavigate } from "react-router-dom";
import DynamicForm from "../../../../../customformComponent/customForm/DynamicForm";
import axiosInstance from "../../../../../services/api/API";
import {
  toastError,
  toastSuccess,
} from "../../../../../customComponents/customToast/Toast";
import { ToastContainer } from "react-toastify";
import { showCustomAlert } from "../../../../../customComponents/CustomSweetAlert";
import { showErrorAlert } from "../../../../../customComponents/CustomSweetAlert/errorsweetalert";
import Loader from "../../../../../customComponents/CustomLoader";
import Swal from "sweetalert2";

const AddNewSource = () => {
  const [formData, setFormData] = useState({});
  const [loading, setLoading] = useState(false);
  const [validationErrors, setValidationErrors] = useState({});

  const [userTypedd, setUserTypedd] = useState([]);
  const userType = localStorage.getItem("UserType");
  console.log(userType, "usertype");
  const businessPartnerId = localStorage.getItem("businessPartnerId");

  const authToken = localStorage.getItem("authToken");

  const navigate = useNavigate();

  // useEffect(() => {
  //   userTypedropdown()
  // },[])
  useEffect(() => {
    if (userType === "superadmin") {
      userTypedropdown();
    }
  }, [userType]);

  const userTypedropdown = async () => {
    try {
      const response = await axiosInstance.get("/bp-onboard/bplist", {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
      });

      const data = response.data.data.data;
      const userTypeOptions = data.map((user) => ({
        value: user.onboard_id,
        label: user.bp_name,
      }));
      setUserTypedd(userTypeOptions);
    } catch (error) {
      console.log(error);
    }
  };

  const handleFormSubmit = async (formData) => {
    const errors = {};
    let isValid = true;
    SourceInputs.forEach((field) => {
      if (field.validation && field.validation.required) {
        if (!formData[field.name]) {
          errors[field.name] = "This field is required";
          isValid = false;
        }
      }
    });
    if (!isValid) {
      setValidationErrors(errors);
      return;
    }
  

    const result = await Swal.fire({
      title: "Confirmation",
      text: "Are you sure you want to add this record?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: "No",
      showLoaderOnConfirm: true,
      preConfirm: async () => {
        try {
          setLoading(true); 
          const payload = {
            source_name: formData.source_name,
            source_desc: formData.description,
            status: formData.status === "Active" ? 1 : 0,
          };
          if (userType === "superadmin") {
            payload.business_partner_id = formData.business_partner_id;
          } else {
            payload.business_partner_id = businessPartnerId;
          }
          const response = await axiosInstance.post('/source/create', payload, {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${authToken}`,
            },
          });
          if (response.status === 200) {
            Swal.fire({
              title: "Success",
              text: "Source added successfully!",
              icon: "success",
              confirmButtonText: "OK",
            }).then(() => {
              navigate('/admin/manage-campaign/source'); 
            });
          }
        } catch (error) {
          console.error('Error adding source:', error);
  
          const errorMessage = error.response?.data?.message || "An error occurred while processing your request.";
          Swal.fire({
            title: "Something went wrong",
            text: errorMessage,
            icon: "error",
            confirmButtonText: "OK",
          });
        } finally {
          setLoading(false); 
        }
      },
    });
  
    if (!result.isConfirmed) {
      setLoading(false); 
    }
  };
  

  const SourceInputs = [
    ...(userType === "superadmin"
      ? [
          {
            name: "business_partner_id",
            label: "Business Partner",
            type: "dropdown",
            required: true,
            options: userTypedd,
            gridClass: "col-lg-4",
          },
        ]
      : []),
    {
      name: "source_name",
      label: "Source Name",
      type: "text",
      placeholder: "Enter Source Name",
      required: true,
      validation: {
        required: true,
        pattern: /^[A-Za-z0-9-\s]*$/,
        message: "Special symbols are not allowed",
      },
      gridClass: "col-lg-4",
    },
    {
      name: "description",
      label: "Description",
      placeholder: "Enter Source Description",
      type: "text",
      required: true,
      validation: { required: true },
      gridClass: "col-lg-4",
    },
    {
      name: "status",
      label: "Status",
      type: "dropdown",
      required: true,
      options: [
        { id: 1, label: "Active", value: "Active" },
        { id: 0, label: "Inactive", value: "Inactive" },
      ],
      gridClass: "col-lg-4",
      validation: { required: true },
    },
  ];

  const backNavigation = () => {
    navigate("/admin/manage-campaign/source");
  };

  return (
    <>
      {loading ? (
        <Loader />
      ) : (
        <>
          <ToastContainer />
          <div onClick={backNavigation} className="backbutton mt-2 mb-2">
            <img src={backicon} alt="back" />
            <span className="backbtntitle">Add New Source</span>
          </div>
          <div className="form-container">
            <span className="cust-det-title mt-2 mb-2">
              Please Enter Source Details
            </span>
            <DynamicForm
              formConfig={SourceInputs}
              formData={formData}
              setFormData={setFormData}
              onSubmit={handleFormSubmit}
              validationErrors={validationErrors}
              setValidationErrors={setValidationErrors}
            />
          </div>

          <div className="btncontainer mt-3">
            <button
              onClick={() => {
                handleFormSubmit(formData);
              }}
              className="submit-btn"
            >
              Submit
            </button>
          </div>
        </>
      )}
    </>
  );
};

export default AddNewSource;
